import { Component, OnInit,ViewChild } from '@angular/core';

import {
  GridPage,
  gridColumns,
  GridtableComponent
} from "../../util/components/gridtable/gridtable.component";
import { Tools } from "../../modules/tools";
import { AuthService } from "../../services/auth.service";
import * as XLSX from "xlsx";
import { SmartchargingModel } from "src/app/models/smartcharging.model";
import { TopbarText } from "../../components/topbar/topbar.component";
import { global } from "../../modules/global";
import {NgbModal, NgbActiveModal,NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {NgYesNoModalContent, NgInformationModalContent} from "../../util/components/modalcomponent/modal-content";
import { StationModel } from "src/app/models/station.model";
import { ChargerService } from "src/app/services/charger.service";
import { StationsService } from "src/app/services/Stations.Service";
import { OperatorModel } from "src/app/models/operator.model";
import { OperatorService } from "src/app/services/operator.service";
import { ManageChargerService } from "src/app/services/ManageCharger.service";
import { ManageChargerModel } from "src/app/models/ManageCharger.model";
import { LogsService } from "../../services/logs.service";
import { Router,ActivatedRoute } from "@angular/router";
import { ChargerComponent } from "../charger/charger.component";
export class searchField {
  operatorId?: number;
  chargerId?: string;
  stationId?: number;
  startdate?: Date;
  enddate?: Date;
  api?:string;
}
export class ChargingValue {
  bytimeto?:string;
  bytimefrom?:string;
  byunit?:string;
  bysupply?:string;
}
@Component({
  selector: 'app-smartcharging',
  templateUrl: './smartcharging.component.html',
  styleUrls: ['./smartcharging.component.css']
})
export class SmartchargingComponent implements OnInit {
  gridcols: gridColumns[] = [
    { columnHeader: "Sr", isSrCol: true, columnClasses: "c-col-pc-3" },
    {
      columnHeader: "Type",
      columnFieldName: "",
      columnClasses: "c-col-pc-10"
    },
    {
      columnHeader: "Name",
      columnFieldName: "",
      columnClasses: "c-col-pc-10"
    },
    {
      columnHeader: "From",
      columnFieldName: "",
      columnClasses: "c-col-pc-8"
    },
    {
      columnHeader: "To",
      columnFieldName: "",
      columnClasses: "c-col-pc-8"
    },
    {
      columnHeader: "Max Demand (W/Hr)",
      columnFieldName: "",
      columnClasses: "c-col-pc-8"
    },
  ];
  logs: Array<object>;
  _action: string;
  data: SmartchargingModel;
    _data: SmartchargingModel;
  chargingValueList:Array<ChargingValue>;
  chargingValue:ChargingValue;
  commercialTypes:string;
  page: GridPage;
  _menuId: string;
  error: any = { isError: false, errorMessage: "" };
  isValidDate: any;
  dateNow: Date = new Date();
  searchField: searchField;
  stationlist: Array<StationModel>;
  station: StationModel;
  operator: OperatorModel;
  iscommercialAllowed = false;
  ischargingdelete: boolean = false;
  operatorlist: Array<OperatorModel>;
  chargerslist: Array<ManageChargerModel>;
  isDetailScreen: boolean = false;
  isOperatorScreen: boolean = false;
  isChargerScreen: boolean = false;
  topbartext: TopbarText[] = [{ key: "loghistory", displayText: "Charging Profile" }];

  constructor(
    private auth: AuthService,
    private ngbModalService: NgbModal,
    private router: Router,
    public tools: Tools,
    private objGlobal: global,
    private objLogService: LogsService,
    public chargerservice: ChargerService,
    private stationservice: StationsService,
    private operatorservice: OperatorService,
    private activatedRoute:ActivatedRoute,
    private managechargerservice: ManageChargerService,
  ) {
    this.data = new SmartchargingModel();
    this.page = new GridPage();
    this.page.size = 10; //Default page size
    this.searchField = new searchField();
   if(this.activatedRoute.snapshot.paramMap.get('chargerId')!=null){
    this.searchField.chargerId=this.activatedRoute.snapshot.paramMap.get('chargerId');
   }else{
   this.searchField.chargerId="All";
   }
   this.searchField.api="All";
  
   this.searchField.startdate=this.dateNow;
   this.searchField.enddate=this.dateNow;
    this._menuId = this.tools.getMenuName(
      "main/smartCharging"
    );
    this.objGlobal.setActiveMenu(this._menuId);
    //console.log(this._menuId);
    //this.objGlobal.setActiveMenu(this._menuId);
    this.getLogs();
  
    this.getChargers();
    //this.getData();
  }

  ngOnInit() {}

  public getSerachResult() {
    
    if (this.validateDates(this.searchField)) {
      //this.getData();
      this.getLogs();
    }
  }
  

  async getChargers() {
    this.chargerslist = undefined;
    await this.managechargerservice
      .getChargersSelectionListWithSuccessorOperator()
      .toPromise()
      .then(data => {
        if (data["success"]) {
          this.chargerslist = data["result"];
        } else {
          console.error("Error in fetching all chargers");
        }
      });
  }

  getChargersList() {
    return this.chargerslist;
    
  }

 
  getLogs() {
    this.objLogService.getLogs(this.page, this.searchField).subscribe(data => {
      if (data["success"]) {
        this.logs = data["result"].content;
        this.page.first = data["result"].first;
        this.page.last = data["result"].last;
        this.page.number = data["result"].number;
        this.page.numberOfElements = data["result"].numberOfElements;
        this.page.offset = data["result"].offset;
        this.page.size = data["result"].size;
        this.page.totalElements = data["result"].totalElements;
        this.page.totalPages = data["result"].totalPages;
        if (this.page.number == 0) {
          
        }
      } else {
        alert("Failed to get Logs!");
      }
    });
  }

  onAddNew(){
    this.data = new SmartchargingModel();
    this._data = this.tools.copyFullObject(this.data);
    let chargingValue: ChargingValue = new ChargingValue();
    this.chargingValueList = new Array<ChargingValue>();
      chargingValue.bytimeto="0";
      chargingValue.bytimefrom="0";
      chargingValue. bysupply="0";
      chargingValue.byunit="w";
      console.log(chargingValue);
      this.chargingValueList.push(chargingValue);
      //this.chargingValueList = chargingList; 
      this.ischargingdelete = true;
    this.isDetailScreen = true;
    this.isOperatorScreen = false;
    this.isChargerScreen = true;
    this._action = "new";
    this.commercialTypes="C";
  }
  hideOperatorScreen() {
    let result: Boolean = true;
    if (this.isDetailScreen) {
      if (!this.isChargerScreen && this.isOperatorScreen) {
        result = false;
      }
    }
    return result;
  }
  hideChargerScreen() {
    let result: Boolean = true;
    if (this.isDetailScreen) {
      if (this.isChargerScreen && !this.isOperatorScreen) {
        result = false;
      }
    }
    return result;
  }
  getData() {
    this.objLogService.getData().subscribe(data => {
      this.logs = data["result"].content;
    });
  }
 
  validateDates(searchField) {
    this.isValidDate = true;
    if (searchField.startdate == null || searchField.enddate == null) {
      this.error = {
        isError: true,
        errorMessage: "Start date and end date are required."
      };
      this.isValidDate = false;
    } else if (
      searchField.startdate != null &&
      searchField.enddate != null &&
      searchField.enddate < searchField.startdate
    ) {
      this.error = {
        isError: true,
        errorMessage: "End date should be grater then start date."
      };
      this.isValidDate = false;
    } else {
      this.error = { isError: false, errorMessage: "" };
      this.isValidDate = true;
    }
    return this.isValidDate;
  }
  downloadExcel () {
    let curdate = new Date();
    let curdatestring = this.tools.formatDateToDDMMYY(curdate);
    const worksheet = XLSX.utils.json_to_sheet(this.logs);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "Logs_"+curdatestring+".xlsx");
  };

  export(){
    var csvData = this.ConvertToCSV( this.logs);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    var x:Date = new Date();
    var link:string ="Logs_"+ this.tools.formatDateToDDMMYY(x) +'.csv';
    a.download = link.toLocaleLowerCase();
    a.click();

  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }
  showAddCommercials(){
    if(this.commercialTypes==="C"){
      let chargingValue: ChargingValue = new ChargingValue();
      if(!this.chargingValueList){
        this.chargingValueList = new Array<ChargingValue>();
        this.chargingValueList[0]. bysupply="0";
        this.chargingValueList[0].bytimefrom="0";
        this.chargingValueList[0].bytimeto="0";
        this.chargingValueList[0].byunit="w";
        }
      chargingValue.bytimeto="0";
      chargingValue.bytimefrom="0";
      chargingValue. bysupply="0";
      chargingValue.byunit="w";
      console.log(chargingValue);
      this.chargingValueList.push(chargingValue);
      //this.chargingValueList = chargingList; 
      this.ischargingdelete = true;
      }
      
  }
  removeCharging(chargingvalueid:number){
    this.iscommercialAllowed=false;
    if(this.chargingValueList && this.chargingValueList.length>1){
      console.log(this.chargingValueList[chargingvalueid])
      this.chargingValueList.splice(chargingvalueid,1)
    }
  }
  isModified() {
    if (!(this.data && this._data)) {
      return false;
    } else if (this.data.name != this._data.name) {
      return true;
    } else if (this.data.type != this._data.type) {
      return true;
    } else if (this.data.recurrence != this._data.recurrence) {
      return true;
    } 
      return false;
  }

  onBackClick(){
    
    if (this.isModified() == true) {
      let ngmodaloptions: NgbModalOptions = {};
      ngmodaloptions.backdrop = "static";
      ngmodaloptions.size = "sm";
      const ngmodalref = this.ngbModalService.open(
        NgYesNoModalContent,
        ngmodaloptions
      );
      ngmodalref.componentInstance.title = "Confirmation";
      ngmodalref.componentInstance.message =
        "Details has been modified. Are you sure to exit without save?";
      ngmodalref.result.then(
        result => {
          if (result == "yes") {
            this._action = "";
            this.isDetailScreen = false;
          }
        },
        reason => {}
      );
    } else {
      this._action = "";
      this.isDetailScreen = false;

    }
  }
  saveData(){
    
  }
  isAllowAddorEdit() {
    let isAllowSave = false;
    if (this._action == "new") {
      isAllowSave = this.auth.isPrivExists(this._menuId + "=>add");
    } else if (this._action == "update") {
      isAllowSave = this.auth.isPrivExists(this._menuId + "=>edit");
    }
    return isAllowSave;
  }
}
